"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _IconFont = _interopRequireDefault(require("./IconFont"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var INNER_SVG_PROPS = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  viewBox: '0 0 32 32'
};

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _classnames;

  var className = props.className,
      type = props.type,
      style = props.style,
      prefixCls = props.prefixCls,
      theme = props.theme,
      size = props.size,
      children = props.children,
      SvgComponent = props.component,
      viewBox = props.viewBox,
      rest = (0, _objectWithoutProperties2["default"])(props, ["className", "type", "style", "prefixCls", "theme", "size", "children", "component", "viewBox"]);
  var cls = (0, _dedupe["default"])(prefixCls, className, (_classnames = {}, (0, _defineProperty2["default"])(_classnames, "".concat(prefixCls, "--").concat(type), !!type), (0, _defineProperty2["default"])(_classnames, "".concat(prefixCls, "--").concat(theme), !!theme), (0, _defineProperty2["default"])(_classnames, "".concat(prefixCls, "--").concat(size), !!size), _classnames));

  var newProps = _objectSpread({
    className: cls,
    style: style,
    type: type,
    theme: theme,
    size: size
  }, rest); // svg component > children by iconfont > type


  if (SvgComponent) {
    INNER_SVG_PROPS.viewBox = viewBox;
    return /*#__PURE__*/_react["default"].createElement("i", (0, _extends2["default"])({}, newProps, {
      ref: ref
    }), /*#__PURE__*/_react["default"].createElement(SvgComponent, INNER_SVG_PROPS, children));
  }

  if (children) {
    return /*#__PURE__*/_react["default"].createElement("i", (0, _extends2["default"])({}, newProps, {
      ref: ref
    }), /*#__PURE__*/_react["default"].createElement("svg", INNER_SVG_PROPS, children));
  }

  if (type) {
    var MyIcon = (0, _IconFont["default"])('//at.alicdn.com/t/font_1285036_9ze0vm44z57.js'); // generated by iconfont.cn

    return /*#__PURE__*/_react["default"].createElement(MyIcon, newProps);
  }

  return null;
});

Icon.createFromIconfont = _IconFont["default"];
Icon.displayName = 'Icon';
Icon.defaultProps = {
  prefixCls: 'za-icon',
  theme: 'default',
  size: 'md',
  viewBox: INNER_SVG_PROPS.viewBox
};
var _default = Icon;
exports["default"] = _default;